export default __webpack_public_path__ + "static/media/cash.95c75169.svg";